export enum Languages {
  LANG_EN = "LANG_EN",
  LANG_ES = "LANG_ES",
}

export enum ArticleType {
  ARTICLE_BIOGRAPHY = "ARTICLE_BIOGRAPHY",
  ARTICLE_DRAMA = "ARTICLE_DRAMA",
  ARTICLE_EDITORIAL = "ARTICLE_EDITORIAL",
  ARTICLE_FICTION = "ARTICLE_FICTION",
  ARTICLE_INFOGRAPHIC = "ARTICLE_INFOGRAPHIC",
  ARTICLE_INFORMATION = "ARTICLE_INFORMATION",
  ARTICLE_MAP = "ARTICLE_MAP",
  ARTICLE_NEWS = "ARTICLE_NEWS",
  ARTICLE_PHOTO = "ARTICLE_PHOTO",
  ARTICLE_POEM = "ARTICLE_POEM",
}

export enum ContentTypeEnum {
  ARTICLE = "ARTICLE",
  INTERACTIVE_VIDEO = "INTERACTIVE_VIDEO",
  BUNDLE = "BUNDLE",
  WORKSHEET = "WORKSHEET",
}

export interface CardViewmodel {
  id: string;
  description: string;
  display_date: string;
  images: ImageViewmodel[];
  generated_date?: string;
  metadata:
    | ArticleCardMetadata
    | BundleCardMetadata
    | InteractiveVideoCardMetadata
    | WorksheetCardMetadata;
  title: string;
  url: string;
  visibility_markers?: VisibilityMarker[];
  viewmodel_type: "card";
}

export interface CardViewmodelAndProps extends CardViewmodel {
  dataQaSelector?: string;
  isContentSettingsEnabled?: boolean;
  contentSettingsGroups?: IContentSettingsGroup[];
}

interface ArticleCardMetadata {
  article_type: ArticleType;
  content_type: ContentTypeEnum.ARTICLE;
  date_lite_product_grant_expires: string | null;
  grade_levels: number[];
  has_formative: boolean;
  has_power_words: boolean;
  lexile_levels: number[];
  languages: Languages[];
  maturity_range: number[];
  reading_skills?: string[];
}

interface BundleCardMetadata {
  asset_count_by_content_type: { [key: string]: number };
  content_type: ContentTypeEnum.BUNDLE;
  label: string;
}

interface InteractiveVideoCardMetadata {
  content_type: ContentTypeEnum.INTERACTIVE_VIDEO;
  duration_in_seconds: number;
}

interface WorksheetCardMetadata {
  content_type: ContentTypeEnum.WORKSHEET;
}

interface ImageViewmodel {
  alt_text?: string;
  auto?: string;
  credit?: string | null;
  crop?: string;
  fit?: string;
  formatted_url: string;
  fp_x?: number;
  fp_y?: number;
  fp_z?: number;
  generated_date: string;
  height?: number;
  id: string | null;
  url: string;
  viewmodel_type?: "image";
  width?: number;
}

interface VisibilityMarker {
  reason: string;
  flagged_at_my_admin_level: boolean;
}

interface IContentSettingsGroup {
  block_sensitive_content: boolean;
  block_student_search: boolean;
  block_teacher_view: boolean;
  created_by_user_id: string;
  date_archived: string | null;
  date_student_search_modified: string | null;
  district_id: string;
  grade_maximum: number;
  grade_minimum: number;
  group_has_flagged_item: boolean;
  id: string;
  school_id: string | null;
}
